/**
 * @public
 */
export type BridgeChannelName = 'dashboard/channels/bridge'

/**
 * @public
 */
export type BridgeNodeName = 'dashboard/nodes/bridge'

/**
 * @public
 */
export const BRIDGE_CHANNEL_NAME: BridgeChannelName = 'dashboard/channels/bridge'

/**
 * @public
 */
export const BRIDGE_NODE_NAME: BridgeNodeName = 'dashboard/nodes/bridge'

/**
 * @public
 */
export type SDKChannelName = 'dashboard/channels/sdk'

/**
 * @public
 */
export type SDKNodeName = 'dashboard/nodes/sdk'

/**
 * @public
 */
export const SDK_CHANNEL_NAME: SDKChannelName = 'dashboard/channels/sdk'

/**
 * @public
 */
export const SDK_NODE_NAME: SDKNodeName = 'dashboard/nodes/sdk'
